import React, { useState } from "react";

export default function MessageModal({ row, onClose }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(row.message || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-title">
            <strong>{row.entityType}</strong>
            <span className="modal-meta"> &mdash; {row.entityId}</span>
            {row.status && (
              <span className="modal-meta"> &nbsp;|&nbsp; {row.status}</span>
            )}
          </div>
          <div className="modal-actions">
            <button className="btn-secondary" onClick={handleCopy}>
              {copied ? "Copied!" : "Copy"}
            </button>
            <button className="btn-close" onClick={onClose}>
              &#x2715;
            </button>
          </div>
        </div>
        <div className="xml-viewer-wrap">
          {row.message ? (
            <pre className="json-pre">{row.message}</pre>
          ) : (
            <div className="xml-loading">No message content.</div>
          )}
        </div>
      </div>
    </div>
  );
}
